import * as React from "react";
import { observer } from "mobx-react";
import { UitkCard, UitkCardContentSection, UitkCardLink } from "uitk-react-cards";
import { UitkImage, UitkFigure, UitkFigureAspectRatioType } from "uitk-react-images";
import { CampaignByIdQuery } from "../../../../../../__generated__/api";
import Offers = CampaignByIdQuery.Offers;
import { Action } from "components/utility/analytics/FlexAnalyticsUtils";
import { TrackedLink } from "components/utility/analytics/TrackedLink";
import { destinationOfferItem } from "../../Common/MerchCampaignCard/MerchCampaignCard";
import { withMabTracker, MabTrackEvent } from "src/components/utility/analytics/MabTracker";

export interface VRCardProps {
  offer: Offers;
  productType: string;
  cardIndex: number;
  campaignId: string;
  displayPropertyCount?: boolean;
  moduleName: string;
  mabTrack?: (x: MabTrackEvent) => null;
}

export const VRCard = withMabTracker(
  observer(({ offer, productType, cardIndex, campaignId, moduleName, displayPropertyCount, mabTrack }: VRCardProps) => {
    if (offer.__typename !== "DestinationOfferItem") {
      return null;
    }

    const offerItem = destinationOfferItem(productType, offer);

    if (offerItem === null || offerItem === undefined) {
      return null;
    }

    const cardClicked = mabTrack
      ? () => {
          const mabTrackData: MabTrackEvent = {
            moduleName: "List_your_property",
            eventTarget: "List_your_property",
            eventType: "homepageClick.nonPath",
            rfrr: "LYP_Homepage",
            // rfrr: `card-${campaignId}-${cardIndex}`,
          };
          mabTrack(mabTrackData);
        }
      : undefined;

    return (
      <>
        <UitkCard className="VRCard uitk-flex-justify-content-flex-start uitk-flex-column">
          <UitkCardContentSection padded={false}>
            <UitkFigure ratio={UitkFigureAspectRatioType.R16_9} className="uitk-card-roundcorner-all">
              <UitkImage src={offer.image.url} alt={offer.image.description} />
            </UitkFigure>
            <UitkCardLink>
              <TrackedLink
                moduleName={moduleName}
                action={Action.CLICK}
                onClick={cardClicked}
                href={offerItem?.actionLink.href}
                rfrr={`card-${campaignId}-${cardIndex}`}
              >
                {offer.name}
              </TrackedLink>
            </UitkCardLink>
          </UitkCardContentSection>
          <div className="uitk-card-content uitk-cell all-t-padding-one">
            <h3 className="uitk-type-heading-400">{offer.name}</h3>
            {displayPropertyCount && offer.propertyCount && (
              <div className="uitk-type-paragraph-300">{offer.propertyCount}</div>
            )}
          </div>
        </UitkCard>
      </>
    );
  })
);
